var _style, _rect, _path, _rect2, _rect3, _rect4, _rect5, _circle, _path2, _rect6, _rect7, _rect8, _g, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path3, _rect19, _path4, _g2, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g3, _rect26, _g4, _g5, _g6, _g7, _g8, _path5, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserActionPagesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 648 648",
    style: {
      enableBackground: "new 0 0 648 648"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000068676506461877186150000014270520343202418831_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#F2F2F2;}\r\n\t.st4{fill:#420083;}\r\n\t.st5{fill:url(#SVGID_00000097495889316333973230000015307146605845318795_);}\r\n\t.st6{fill:url(#SVGID_00000181058132502483692900000004678340349260086454_);}\r\n\t.st7{fill:url(#SVGID_00000143617868846812548990000018078806442329507987_);}\r\n\t.st8{fill:url(#SVGID_00000126291176069376003480000009973766476009811088_);}\r\n\t.st9{fill:url(#SVGID_00000114786437663343815730000006243155237904862108_);}\r\n\t.st10{fill:url(#SVGID_00000102522091740748528230000000785782970607039910_);}\r\n\t.st11{fill:url(#SVGID_00000114063985302888989750000005340987086818318997_);}\r\n\t.st12{fill:url(#SVGID_00000008866733805663186080000012480383132485990024_);}\r\n\t.st13{fill:url(#SVGID_00000177461142093762167250000017866419171687776421_);}\r\n\t.st14{fill:#442B7E;}\r\n\t.st15{fill:#299BCB;}\r\n\t.st16{fill:#00C0CF;}\r\n\t.st17{fill:#FFBE00;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.7005,
    y1: 361.9828,
    x2: 803.7005,
    y2: 752.6364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#420083"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4200B8"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.6,
    y: -12.9,
    className: "st0",
    width: 667.2,
    height: 667.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029760035915327613380000003140852319767314094_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.8047,
    y1: 507.1307,
    x2: 579.1314,
    y2: 109.3485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3192"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029760035915327613380000003140852319767314094_)"
    },
    d: "M527.6,132.1v371c0,14.4-11.6,26-26,26 H150.5c-14.4,0-26-11.6-26-26v-371c0-14.4,11.6-26,26-26h351.1C515.9,106.1,527.6,117.8,527.6,132.1z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M535.6,483.2H116.4c-7.1,0-12.8-5.7-12.8-12.8V170.6c0-6.9,5.6-12.5,12.5-12.5H536c6.9,0,12.5,5.6,12.5,12.5 v299.8C548.4,477.5,542.7,483.2,535.6,483.2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.8,
    y: 174.5,
    className: "st3",
    width: 76.3,
    height: 15.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 278.6,
    y: 174.5,
    className: "st3",
    width: 76.3,
    height: 15.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 399.4,
    y: 174.5,
    className: "st3",
    width: 52.3,
    height: 15.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 174.5,
    className: "st3",
    width: 52.3,
    height: 15.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 531.3,
    cy: 182.4,
    r: 7.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M439.4,482.9H191.1V237.4c0-6.8,5.5-12.3,12.3-12.3h223.7c6.8,0,12.3,5.5,12.3,12.3V482.9z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 205.2,
    y: 283.6,
    className: "st2",
    width: 66.9,
    height: 49.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 282.9,
    y: 283.6,
    className: "st2",
    width: 66.9,
    height: 49.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 360.6,
    y: 283.6,
    className: "st2",
    width: 66.9,
    height: 49.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.2,
    y: 239.3,
    className: "st2",
    width: 77,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.2,
    y: 257.2,
    className: "st2",
    width: 119.8,
    height: 10
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 203.3,
    y: 346,
    className: "st2",
    width: 223.7,
    height: 136.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 353.1,
    className: "st3",
    width: 53.1,
    height: 12.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 375.9,
    className: "st3",
    width: 149.2,
    height: 12.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 375.9,
    className: "st3",
    width: 29.9,
    height: 12.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 395.5,
    className: "st3",
    width: 29.9,
    height: 12.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 415.1,
    className: "st3",
    width: 29.9,
    height: 12.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 434.7,
    className: "st3",
    width: 29.9,
    height: 12.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 395.5,
    className: "st3",
    width: 149.2,
    height: 12.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 415.1,
    className: "st3",
    width: 149.2,
    height: 12.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 434.7,
    className: "st3",
    width: 149.2,
    height: 12.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M344,473.6h-57.7c-1.4,0-2.5-1.1-2.5-2.5V464c0-1.4,1.1-2.5,2.5-2.5H344c1.4,0,2.5,1.1,2.5,2.5v7.1 C346.5,472.5,345.3,473.6,344,473.6z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 353.1,
    className: "st3",
    width: 73.1,
    height: 12.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M531.8,373.4H456c-4.9,0-8.9-4-8.9-8.9V234.1c0-4.9,4-8.9,8.9-8.9h75.8c4.9,0,8.9,4,8.9,8.9v130.5 C540.7,369.4,536.7,373.4,531.8,373.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 191.1,
    y: 203.1,
    className: "st3",
    width: 46.7,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.1,
    y: 211.6,
    className: "st3",
    width: 82.7,
    height: 3.9
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 246.8,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 268.6,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 290.5,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 312.4,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 334.2,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 356.1,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 246.8,
    className: "st4",
    width: 9.5,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 268.6,
    className: "st4",
    width: 9.5,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 290.5,
    className: "st4",
    width: 9.5,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 312.4,
    className: "st4",
    width: 9.5,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 334.2,
    className: "st4",
    width: 9.5,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 356.1,
    className: "st4",
    width: 9.5,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 378,
    className: "st4",
    width: 9.5,
    height: 9.3
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 378,
    className: "st3",
    width: 51.6,
    height: 9.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141450607140746913980000016219439980815411852_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.0217,
    y1: 83.0378,
    x2: 97.8172,
    y2: 70.8611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00669D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A99D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000141450607140746913980000016219439980815411852_)"
    },
    cx: 90.1,
    cy: 77.2,
    r: 8.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070803152699823810990000013338146676709344654_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1405,
    y1: 112.622,
    x2: 289.936,
    y2: 100.4452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00669D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A99D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000070803152699823810990000013338146676709344654_)"
    },
    cx: 282.2,
    cy: 106.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176734190192967974980000013879667341513407918_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.8614,
    y1: 54.4257,
    x2: 416.5644,
    y2: 54.4257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00669D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A99D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000176734190192967974980000013879667341513407918_)"
    },
    cx: 413.7,
    cy: 54.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062907963274801414880000015830763595528783524_",
    gradientUnits: "userSpaceOnUse",
    x1: 341,
    y1: 600.4852,
    x2: 346.703,
    y2: 600.4852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00669D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A99D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000062907963274801414880000015830763595528783524_)"
    },
    cx: 343.9,
    cy: 600.5,
    r: 2.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100382019384744043850000010700807803564468365_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.0128,
    y1: 590.6508,
    x2: 562.206,
    y2: 572.3856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00669D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A99D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000100382019384744043850000010700807803564468365_)"
    },
    cx: 550.6,
    cy: 582,
    r: 12.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157297862909896257200000016844016785390207900_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.2772,
    y1: 520.6436,
    x2: 82.9406,
    y2: 520.6436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000157297862909896257200000016844016785390207900_)"
    },
    cx: 70.1,
    cy: 520.6,
    r: 12.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045602459018303990120000010775841019628491709_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.1782,
    y1: 530.6238,
    x2: 415.1386,
    y2: 530.6238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000045602459018303990120000010775841019628491709_)"
    },
    cx: 405.2,
    cy: 530.6,
    r: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109749321749405826680000011301459863631169671_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.0693,
    y1: 602.6238,
    x2: 173.4753,
    y2: 602.6238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000109749321749405826680000011301459863631169671_)"
    },
    cx: 167.8,
    cy: 602.6,
    r: 5.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054260065526434231830000016911885732793993856_",
    gradientUnits: "userSpaceOnUse",
    x1: 573.0396,
    y1: 198.7822,
    x2: 590.1485,
    y2: 198.7822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000054260065526434231830000016911885732793993856_)"
    },
    cx: 581.6,
    cy: 198.8,
    r: 8.6
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M145.2,228.3c-15.2,0-27.6-12.4-27.6-27.6c0-15.5,12.3-27.9,27.6-27.9c15.3,0,27.6,12.4,27.6,28 C172.8,215.9,160.3,228.3,145.2,228.3z M145.1,176.4c-13.5,0-24.3,10.8-24.4,24.2c0,13,10.4,24.4,24.3,24.3 c13.9,0,24.2-11.2,24.3-24.1C169.4,187.3,158.6,176.4,145.1,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M145.1,222.5c-12.1,0-21.9-9.8-21.9-21.9c0-12,9.8-21.8,21.9-21.8c11.7,0,21.9,9.3,21.9,21.9 C166.9,213.6,156.4,222.6,145.1,222.5z M142.4,199.4c-0.3,3.6-0.9,7.2-2.1,10.6c-0.6,1.7-1.3,3.4-1.9,5.1c-0.2,0.6-0.2,1.2,0.4,1.7 c0.5,0.4,1,0.4,1.5,0c0.3-0.2,0.5-0.5,0.6-0.8c1.2-2.7,2.4-5.4,3.6-8.2c0.1-0.3,0.4-0.4,0.6-0.7c0.2,0.2,0.5,0.4,0.6,0.7 c0.5,1.2,1,2.4,1.5,3.6c0.7,1.6,1.4,3.1,2.1,4.7c0.4,0.9,1.1,1.3,1.8,1c0.8-0.3,1-1,0.6-2c0-0.1-0.1-0.2-0.1-0.3 c-1.5-3.8-2.8-7.6-3.4-11.6c-0.2-1.3-0.3-2.6-0.5-3.8c-0.1-1.2,0.8-1.9,2.2-2.1c2.6-0.3,5.2-0.6,7.8-1c0.7-0.1,1.2-0.5,1.3-1.2 c0.1-1-0.7-1.6-1.9-1.4c-2.9,0.4-5.8,0.8-8.7,1c-5.2,0.3-10.4,0-15.6-1c-0.9-0.2-1.6,0.2-1.7,1c-0.2,0.9,0.3,1.5,1.3,1.7 c2.6,0.3,5.2,0.7,7.8,0.9C141.7,197.3,142.4,198,142.4,199.4z M145.1,193.1c2.4,0,4.3-1.9,4.3-4.2c0-2.4-1.9-4.3-4.3-4.3 c-2.4,0-4.3,1.9-4.3,4.3C140.8,191.2,142.7,193.1,145.1,193.1z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 480,
    height: 360,
    xlinkHref: "AIOA logo.png",
    transform: "matrix(1 0 0 1 -910.5643 -364.3861)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -828.1,
    y: 360.6,
    className: "st14",
    width: 25.7,
    height: 81.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -750.8,
    y: 335.8,
    className: "st14",
    width: 27.3,
    height: 106.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -674.1,
    y: 313.9,
    className: "st14",
    width: 27.3,
    height: 128.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -712.8,
    y: 290.2,
    className: "st14",
    width: 27.3,
    height: 152
  }), /*#__PURE__*/React.createElement("rect", {
    x: -789.6,
    y: 384,
    className: "st14",
    width: 25.7,
    height: 58.3
  })), /*#__PURE__*/React.createElement("rect", {
    x: -839,
    y: 447,
    className: "st14",
    width: 204.4,
    height: 3.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 306.5,
    className: "st14",
    width: 6.7,
    height: 21.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 300,
    className: "st14",
    width: 7.1,
    height: 27.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 294.3,
    className: "st14",
    width: 7.1,
    height: 33.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.9,
    y: 288.2,
    className: "st14",
    width: 7.1,
    height: 39.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.9,
    y: 312.5,
    className: "st14",
    width: 6.7,
    height: 15.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 212.1,
    y: 328.9,
    className: "st14",
    width: 53.1,
    height: 0.9
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 316.3,
    cy: 308.4,
    r: 21.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M337.2,303.3c-2.3-9.4-10.8-16.4-20.9-16.4v21.6L337.2,303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M316.3,308.4h21.6c0-1.7-0.2-3.4-0.6-5L316.3,308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M329.3,325.7c5.2-3.9,8.6-10.2,8.6-17.2h-21.6L329.3,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M316.3,330c4.9,0,9.5-1.7,13.1-4.4l-13.1-17.1l-14.2,16.2C305.9,328,310.8,330,316.3,330z"
  }))), /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 394,
    cy: 308.4,
    r: 20.1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M394,308.4l19.6-4.1c0.3,1.4,0.4,2.7,0.4,4.1c0,11-9.1,20.1-20.1,20.1c-11,0-20.1-9.1-20.1-20.1 c0-11,9.1-20.1,20.1-20.1V308.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 72,
    height: 73,
    xlinkHref: "7C84268A.png",
    transform: "matrix(1 0 0 1 358 272)"
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 394,
    cy: 308.4,
    r: 11.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActionPagesImage);
export default __webpack_public_path__ + "static/media/user-action-pages-image.ff78b47af32625543a25451bfdbeaa2b.svg";
export { ForwardRef as ReactComponent };